import { buildDevPortalUrl } from '../utils/environmentUtils';
export const EXTERNAL_URLS = {
  // navbar
  AIRKEY_HOME: 'https://airkey.com/',
  DEVELOPER_PORTAL_ADMIN: buildDevPortalUrl('admin/dashboard'),
  DEVELOPER_PORTAL_DOCS: buildDevPortalUrl('docs'),
  DEVELOPER_PORTAL_HOME: buildDevPortalUrl(''),
  DEVELOPER_PORTAL_PROFILE: buildDevPortalUrl('settings/profile'),
  DEVELOPER_PORTAL_SANDBOX: buildDevPortalUrl('sandbox'),
  DEVELOPER_PORTAL_LOGOUT: '/api/auth/logout', // relative to dev portal base URL in axios client, so no need to build full URL

  // footer general links
  IP_NOTICE: 'https://airkey.com/ipinfo/',
  PATENTS: 'https://airkey.com/patents/',
  PRIVACY_POLICY: 'https://www.capitalone.com/privacy/online-privacy-policy/',
  TERMS_AND_CONDITIONS: buildDevPortalUrl('terms-conditions'),

  // footer docs links
  AIRKEY_APPLET: buildDevPortalUrl('docs/airkey-applet'),
  AIRKEY_SDK: buildDevPortalUrl('docs/airkey-sdk'),
  CARD_REGISTRATION: buildDevPortalUrl('docs/card-registration'),
  GUIDES: buildDevPortalUrl('docs/guides'),
  INTRODUCTION_TO_AIRKEY: buildDevPortalUrl('docs/introduction-to-airkey'),
  SUPPORT: buildDevPortalUrl('docs/support'),
  SWITCHBOARD: buildDevPortalUrl('docs/switchboard'),
  VALIDATOR: buildDevPortalUrl('docs/validator'),

  // footer sandbox links
  SANDBOX_3DS: buildDevPortalUrl('sandbox/use-cases/3ds'),
  SANDBOX_ACCOUNT_SETUP: buildDevPortalUrl('sandbox/use-cases/account-setup'),
  SANDBOX_BANK_APP_LOGIN: buildDevPortalUrl('sandbox/use-cases/login'),
  SANDBOX_BUILD_YOUR_OWN: buildDevPortalUrl('sandbox/make-your-own'),
  SANDBOX_ZELLE_TRANSFER: buildDevPortalUrl(
    'sandbox/use-cases/zelle-transaction',
  ),
};
